import FormInput from "@/components/formInputFields/FormInput";
import FormTextarea from "@/components/formInputFields/FormTextarea";
import FormSelect from "@/components/formInputFields/FormSelect";
import FormCard from "@/components/formInputFields/FormCard";

import ProductImageUpload from "./ProductImageUpload";

const BasicInfoSection = ({ register, errors, setValue, watch, setError, clearErrors }) => {
  return (
    <div className="flex flex-row gap-[1em] ">
      {/* Left Section: Main Product Info */}
      <FormCard className="w-full max-w-3xl">
        {/* Product name field */}
        <FormInput
          label="Product Name"
          name="productName"
          placeholder="Enter product name"
          register={register}
          error={errors?.productName}
        />

        {/* Product Description field */}
        <FormTextarea
          label="Description"
          name="productDescription"
          placeholder="Enter product description"
          rows={5}
          register={register}
          error={errors?.productDescription}
        />

        {/* Product Image Upload */}
        {/* TODO: Implement logic for image upload, previewing and laoding. SHow the loaded images. */}
        {/* TODO: Use dnd-kit to implement reodrdering of product images */}
        <ProductImageUpload
          value={watch("productImages")}
          onChange={(imgs) => {
            setValue("productImages", imgs, { shouldDirty: true });
            clearErrors("productImages");
          }}
          error={errors?.productImages}
          setError={setError}
          clearErrors={clearErrors}
        />

        {/* Product Category selector */}
        {/* TODO: Will have to implement the Shopifys way thats shows various categories and sub categories. */}
        <FormSelect
          label="Category"
          name="productCategory"
          placeholder="Select a category"
          options={[
            { value: "uncategorized", label: "Uncategorized" },
            { value: "perfume", label: "Perfume" },
            { value: "gift", label: "Gift Sets" },
            { value: "men's perfume", label: "Men's Perfume" },
            { value: "unisex", label: "Unisex" }
          ]}
          register={register}
          error={errors?.productCategory}
        />
      </FormCard>

      {/* Product Status */}
      <FormCard className="w-full max-w-xs h-fit">
        <h2 className="text-md font-semibold text-gray-800 mb-4">Status</h2>

        <FormSelect
          label="Product Status"
          name="productStatus"
          placeholder="Select a Product Status"
          options={[
            { value: "active", label: "Active" },
            { value: "draft", label: "Draft" },
            { value: "archived", label: "Archived" },
          ]}
          register={register}
          error={errors?.productStatus}
        />
      </FormCard>
    </div>
  );
};

export default BasicInfoSection;